import styled from "./index.module.scss";
import { useState, useEffect, useRef } from "react";
import { useSize } from "ahooks";
import { checkOverflow } from "./utils";

const TextEllipsis = ({ children, onClick, style, rowindex, testid }: any) => {
  const size = useSize(document.body);
  const [isEllipsis, setIsEllipsis] = useState(null);
  const buttonRef = useRef(null);

  useEffect(() => {
    if (!buttonRef.current) return;
    const isTextEllipsis = checkOverflow(buttonRef.current);

    // @ts-ignore
    setIsEllipsis(isTextEllipsis);
  }, [children, size]);

  return (
    <button
      style={style}
      ref={buttonRef}
      className={`${styled.buttonContainer} ${
        isEllipsis ? styled.buttonContainerEllipsisHover : ""
      }`}
      onClick={(event) => {
        isEllipsis && onClick && onClick(event, isEllipsis);
      }}
      data-testid={testid}
    >
      {/* @ts-ignore */}
      <span rowindex={rowindex}>{children}</span>
    </button>
  );
};

export default TextEllipsis;
